import { all, put, select, takeEvery, takeLeading } from 'redux-saga/effects';
import { api, commonApiSaga } from 'redux/helpers/api';
import { snackbarActions } from 'redux/snackbar';
import { takeLeadingPerKey } from 'redux/helpers/saga';
import actions from './actions';
import selectors from './selectors';
import types from './types';

const PUBLISHED_DURATION = 8000;

function* onPublishShareSuccess({ payload }) {
  const postId = payload?.data?.resultingPostId;

  yield put(snackbarActions.createSuccess('post.publishedFromNetwork', {
    autoHideDuration: PUBLISHED_DURATION,
    ...(postId && { link: { label: 'common:managePosts.goToPost', to: `/post/${postId}` } }),
  }));
}

// A share nobody had acted on is gone, so the card goes too.
function* onShareWithdrawn({ payload }) {
  if (payload.data?.removed) {
    yield put(actions.removeNetworkFeedItem({ id: payload.request.shareId }));
  }

  yield put(snackbarActions.createSuccess('post.withdrawnFromNetwork', {
    values: { count: payload.data?.recipientsWithdrawn ?? 0 },
  }));
}

// The pending counts above the feed no longer match once a share leaves it.
function* onShareResolved() {
  yield put(actions.getNetworkSettings());
}

// The list is one card shorter, so the gap is refilled early.
function* onFeedItemRemoved() {
  const { hasMore, nextPage } = yield select(selectors.getFeedPagination);

  if (hasMore) {
    const filter = yield select(selectors.getFeedFilter);

    yield put(actions.getNetworkFeed({ filter, page: nextPage }));
  }
}

export default function* networkSagas() {
  yield all([
    takeLeading(types.getNetworkFeed, commonApiSaga, { apiFn: api.post.getNetworkFeed, workspaceId: true, failureMessage: false }),
    takeLeadingPerKey(types.resolveNetworkShare, commonApiSaga, ({ payload }) => payload.targetId, { apiFn: api.post.resolveNetworkShare, workspaceId: true }),
    takeLeadingPerKey(types.publishNetworkShare, commonApiSaga, ({ payload }) => payload.targetId, { apiFn: api.post.publishNetworkShare, workspaceId: true }),
    takeLeadingPerKey(types.withdrawNetworkShare, commonApiSaga, ({ payload }) => payload.shareId, { apiFn: api.post.withdrawNetworkShare, workspaceId: true }),
    takeEvery(types.removeNetworkFeedItem, onFeedItemRemoved),
    takeEvery(types.publishNetworkShareSuccess, onPublishShareSuccess),
    takeEvery(types.withdrawNetworkShareSuccess, onShareWithdrawn),
    takeEvery([types.resolveNetworkShareSuccess, types.publishNetworkShareSuccess], onShareResolved),

    takeLeading(types.getNetworkSettings, commonApiSaga, { apiFn: api.post.getNetworkSettings, workspaceId: true }),
    takeLeading(types.getNetworkAutoPostCandidates, commonApiSaga, { apiFn: api.post.getNetworkAutoPostCandidates, workspaceId: true }),
    takeLeadingPerKey(types.updateNetworkSettings, commonApiSaga, ({ payload }) => payload.networkId, { apiFn: api.post.updateNetworkSettings, workspaceId: true, successMessage: 'post.autoPostUpdated' }),
  ]);
}
